const apis = {
    apiTip: '取引ニーズに応じてAPIキーを作成します。資産の安全を確保するため、APIキーを漏洩しないようにしてください。',
    cjapi: 'APIを作成',
    bzm: '備考名',
    qx: '権限',
    cjrq: '作成日',
    cz: '操作',
    ck: '表示',
    bj: '編集',
    sc: '削除',
    mm: 'パスフレーズ',
    qsrmm: 'パスフレーズを入力してください',
    sjyzm: '携帯電話認証コード',
    qsryzm: '認証コードを入力してください',
    yxyzm: 'メール認証コード',
    dzbmd: 'IPアドレスホワイトリスト（オプション）',
    my: '秘密鍵',
    cancel: 'キャンセル',
    confirm: '確認',
    fzapi: 'API情報をコピー',
    qdsc: '{name} APIを削除しますか？',
    tip: 'ヒント',
    sccg: '削除に成功しました！',
    yqxsc: '削除をキャンセルしました',
    tips: '注：',
    zdcy: '各メインアカウントとサブアカウントは最大50個のアクティブなAPIキーを持つことができます。',
    qwxl: 'APIキーを漏洩しないでください。APIキーをIPにバインドすることで、セキュリティが大幅に向上します。',
    dsfbd: '取引と引き出し権限を持つAPIを第三者プラットフォームにバインドすると、API情報が漏洩する可能性があるため、慎重に操作してください。',
    zdsc: '資金の安全のため、IPアドレスにバインドされておらず、取引または引き出し権限を持つAPIキーは、14日間の非アクティブ後に自動的に削除され、再申請が必要になります。IPにバインドされている、または読み取り専用権限を持つAPIキーには有効期限はありません。',
    dq: '読み取り',
    jy: '取引',
    ljcj: '今すぐ作成',
    qsrbzm: '備考名を入力してください',
    cjcg: '作成に成功しました',
    czapi: 'APIをリセット',
    cjlc: 'APIキーを作成するをクリック > 独自のAPIキーおよび関連情報を作成 > APIドキュメントの詳細を表示 > 開発取引を行う',
    zdbddz: '各APIキーには最大20個のIPアドレスをバインドできます。複数のIPアドレスを追加するには、半角コンマで区切ります。',
    xgcg: '変更に成功しました',
  }
  
export {
    apis
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/api/ja_JP.js